import { IApplicationState } from '../../types/redux';

export function getLkType(state: IApplicationState) {
  return state.lkType;
}
